import React from "react";

const Assistencia = () => {
  return (
    <div className="work-section-wrapper">
      <h1>
        Com nossa assistência 24 horas, você nunca estará sozinho na estrada!
      </h1>
      <p>Conte conosco em cada curva da sua jornada.</p>

    </div>
  );
};

export default Assistencia;
